// 更改树组件的颜色，比如将重复的节点标红

import '../styles/DuplicateHighlightTree.css';

export const enhanceTreeDataWithStyling = (treeData) => {
    return treeData.map(node => {
        let enhancedNode = { ...node };

        if (node.isDuplicate) {
            enhancedNode.title = (
                <span className="duplicate-section">
                    {node.title}
                </span>
            );
        }

        if (node.children) {
            enhancedNode.children = enhanceTreeDataWithStyling(node.children);
        }

        return enhancedNode;
    });
};